module.exports = __webpack_public_path__ + "img/yun.5eed08a3.svg";